'use strict';

var summaryBase = require('base/checkout/summary');

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
    const shippingCostValue = totals.totalShippingCost.replace(/[$.]/g, "").replace(",", ".");

    $('.shipping-total-cost').text(totals.totalShippingCost);
    $('.tax-total').text(totals.totalTax);
    $('.sub-total').text(totals.subTotal);
    $('.grand-total-sum').text(totals.grandTotal);
    $('.shipping-total-cost').parents('.shipping-item').removeClass('d-none');

    if (totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').text('- ' + totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (totals.shippingLevelDiscountTotal.value >= shippingCostValue) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').text(' Gratis');
        $('.shipping-total-cost').parents('.shipping-item').addClass('d-none');
    } else if (totals.shippingLevelDiscountTotal.value > 1) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').text('- ' +
            totals.shippingLevelDiscountTotal.formatted);
        $('.shipping-total-cost').parents('.shipping-item').removeClass('d-none');
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (totals.totalGiftPrice.value > 0) {
        $('.gift-item').removeClass('hide-shipping-discount');
        $('.gift-summary').show();
        $('.summary-details-gift').show();
        $('.gift-total-cost').text(totals.totalGiftPrice.formatted);
    } else {
        $('.gift-summary').hide();
        $('.summary-details-gift').hide();
        $('.gift-item').addClass('hide-shipping-discount');
    }
    if (totals.valueCFT.value > 0) {
        $('.cft-item').removeClass('hide-shipping-discount');
        $('.cft-total-cost').text(totals.valueCFT.formatted);
    } else {
        $('.cft-item').addClass('hide-shipping-discount');
    }
}

/**
 * updates the order product shipping summary for an order model
 * @param {Object} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
    var $productSummary = $('<div />');
    order.shipping.forEach(function (shipping) {
        shipping.productLineItems.items.forEach(function (lineItem) {
            var pli = $('[data-product-line-item=' + lineItem.UUID + ']');
            $productSummary.append(pli);
        });
        var address = shipping.shippingAddress || {};
        var selectedMethod = shipping.selectedShippingMethod;
        var nameLine = address.firstName ? address.firstName + ' ' : '';
        if (address.lastName) nameLine += address.lastName;
        var address1Line = address.address1;
        var addressNumber = (address.custom && address.custom.number) ? address.custom.number : '';
        var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
        var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
        var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
            ? '( ' + selectedMethod.estimatedArrivalTime + ' )'
            : '';
        var tmpl = $('#pli-shipping-summary-template').clone();
        if (shipping.productLineItems.items && shipping.productLineItems.items.length > 1) {
            $('h5 > span').text(' - ' + shipping.productLineItems.items.length + ' '
                + order.resources.items);
        } else {
            $('h5 > span').text('');
        }
        var stateRequiredAttr = $('#shippingState').attr('required');
        var isRequired = stateRequiredAttr !== undefined && stateRequiredAttr !== false;
        var stateExists = (shipping.shippingAddress && shipping.shippingAddress.stateCode)
            ? shipping.shippingAddress.stateCode
            : false;
        var stateBoolean = false;
        if ((isRequired && stateExists) || (!isRequired)) {
            stateBoolean = true;
        }
        var numberTemplate = $('.ship-to-number', tmpl);
        var shippingForm = $('.multi-shipping input[name="shipmentUUID"][value="' + shipping.UUID + '"]').parent();
        if (shipping.shippingAddress
            && shipping.shippingAddress.firstName
            && shipping.shippingAddress.address1
            && shipping.shippingAddress.city
            && shipping.shippingAddress.custom.number
            && stateBoolean
            && shipping.shippingAddress.countryCode) {
            $('.ship-to-name', tmpl).text(nameLine);
            numberTemplate.text(addressNumber);
            $('.ship-to-address1', tmpl).text(address1Line + ' ').append(numberTemplate);
            $('.ship-to-city-st-zip', tmpl).text(address.city + ', ' + (address.custom && address.custom.state ? address.custom.state : '') + ' ' + address.postalCode);
            shippingForm.find('.ship-to-message').text('');
        } else {
            shippingForm.find('.ship-to-message').text(order.resources.addressIncomplete);
        }
        if (shipping.isGift) {
            $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        } else {
            $('.gift-summary', tmpl).addClass('d-none');
        }
        // checking h5 title shipping to or pickup
        var $shippingAddressLabel = $('.shipping-header-text', tmpl);
        $('body').trigger('shipping:updateAddressLabelText',
            { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });
        if (shipping.selectedShippingMethod) {
            $('.display-name', tmpl).text(methodNameLine);
            $('.arrival-time', tmpl).text(methodArrivalTime);
            $('.price', tmpl).text(shippingCost);
        }
        var $shippingSummary = $('<div class="multi-shipping" data-shipment-summary="'
            + shipping.UUID + '" />');
        $shippingSummary.html(tmpl.html());
        $productSummary.append($shippingSummary);
    });
    $('.product-summary-block').html($productSummary.html());
    // Also update the line item prices, as they might have been altered
    $('.grand-total-price').text(order.totals.subTotal);
    order.items.items.forEach(function (item) {
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
}

function updateProductsTotals(Items) {
    // Also update the line item prices, as they might have been altered
    Items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
}

summaryBase.updateOrderProductSummaryInformation = updateOrderProductSummaryInformation;
summaryBase.updateTotals = updateTotals;
summaryBase.updateProductsTotals = updateProductsTotals;

module.exports = summaryBase;
